import { UseFormReturn } from "react-hook-form";

import { ModulerRiskForm } from "src/core/components/folder/cartography/ModulerRiskForm";
import { ISelectOption } from "src/core/constants/options";
import { CustomRiskLevel } from "src/core/constants/risk";
import { ModulerRiskFormValues } from "src/core/forms/cartography/modulerRisk.schema";

type Props = {
  riskTabKey: string;
  selectedRiskTab?: CustomRiskLevel;
  globalRiskLevel?: CustomRiskLevel;
  form: UseFormReturn<ModulerRiskFormValues>;
  onSubmit: (data: ModulerRiskFormValues) => void;
  isLoading: boolean;
  isReadOnly: boolean;
  forcedRiskReasonOptions: ISelectOption[];
  setOpen: (open: boolean) => void;
};

export const RiskTabContent = ({
  riskTabKey,
  selectedRiskTab,
  globalRiskLevel,
  form,
  onSubmit,
  isLoading,
  isReadOnly,
  forcedRiskReasonOptions,
  setOpen,
}: Props) => {
  // Dans le cas où on a déjà modulé, il doit être possible de revenir au niveau de risque originel.
  if (riskTabKey === selectedRiskTab && globalRiskLevel === selectedRiskTab) {
    return null;
  }

  return (
    <div data-testid="risk-tab-moduler-form">
      <ModulerRiskForm
        form={form}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isReadOnly={isReadOnly}
        forcedRiskReasonOptions={forcedRiskReasonOptions}
        setOpen={setOpen}
      />
    </div>
  );
};
